/**
 * Determines the jurisdiction level based on government entity and local jurisdiction values
 *
 * Business Rules:
 * - If there is a local jurisdiction value: return "Local"
 * - If there is no local jurisdiction but there is a governmentEntity (State/Province): return "State"
 * - If there is no governmentEntity and no local jurisdiction: return "Federal"
 *
 * @param governmentEntity - The state/province value
 * @param localJurisdiction - The local jurisdiction value
 * @returns "Local" | "State" | "Federal"
 */
export const determineJurisdictionLevel = (
  governmentEntity?: string,
  localJurisdiction?: string
): string => {
  if (localJurisdiction && localJurisdiction.trim() !== "") {
    return "Local";
  }
  if (governmentEntity && governmentEntity.trim() !== "") {
    return "State";
  }
  return "Federal";
};
